export default __webpack_public_path__ + "static/media/Group2830@2x.1da8c718.png";